<template>
    <div class="container" :id="id + '_container'" style="height: 100vh; width: 100vw;">
        
    </div>
</template>
<script>
var methods = {}
import PSPDFKit from 'pspdfkit';

const baseUrl = `${window.location.protocol}//${window.location.host}/`;

methods.load = function () {
    // var baseUrl = this.$apiAdress + '/storage/'
    // var baseUrl = ''
    console.log(this.id)
    console.log(baseUrl)
    PSPDFKit.load({
        baseUrl: baseUrl,
        document: this.$apiAdress + '/storage/test.pdf',
        container: ".container"
    })
}

methods.unload = function () {
    if (this._instance) {
        PSPDFKit.unload(this._instance || ".container");
        this._instance = null;
    }
}

export default {
    // ===Component name
    name: "PSPDFWrapper",
    // ===Props passed to component
    props: ['documentUrl', 'id'],
    _instance: null,
    // ===Components used by this component
    components: {
        PSPDFKit
    },
    // ====component Data properties
    data(){
        return{

        }
    },
    watch: {
        documentUrl: function documentUrl() {
                this.unload();
                this.load();
        }
    },
    beforeDestroy: function beforeDestroy() {
        this.unload();
    },
    // ===Code to be executed when Component is mounted
    mounted() {
        this.load()
    },
    // ===Computed properties for the component
    computed: {},
    // ===Component methods
    methods: methods
}
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped></style>
